import { Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import endpoint from "../../../config/endpoints";
import { DriverJson } from "../../../DynamicFormsJson/MastersJSON/driverJson";
import { apiGet } from "../../../utils/api_service";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import { noInternetMsg } from "../../../config/messageconstant";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

class DriverView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            DataToSet: [],
        };
    }
    async componentDidMount() {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            if (this.props.params.id) {
                showLoador({ loador: true });
                await apiGet({
                    url: endpoint.salesExecutive + "/by-id?id=" + this.props.params.id,
                }).then(({ data, success }) => {

                    showLoador({ loador: false });
                    if (!success) {
                    } else {

                        let dataObj = data.data;

                        let DataToSet = [
                            {
                                xs: 12,
                                sm: 6,
                                md: 6,
                                lg: 6,
                                label: "Region",
                                value:
                                    dataObj.regionNames !== null ? dataObj.regionNames : "",
                            },
                            {
                                xs: 12,
                                sm: 6,
                                md: 6,
                                lg: 6,
                                label: "State",
                                value:
                                    dataObj.stateNames !== null ? dataObj.stateNames : "",
                            },
                            {
                                xs: 12,
                                sm: 6,
                                md: 6,
                                lg: 6,
                                label: "Zone",
                                value:
                                    dataObj.zoneNames !== null ? dataObj.zoneNames : "",
                            },
                            {
                                xs: 12,
                                sm: 6,
                                md: 6,
                                lg: 6,
                                label: "District",
                                value:
                                    dataObj.districtNames !== null ? dataObj.districtNames : "",
                            },
                            {
                                xs: 12,
                                sm: 6,
                                md: 6,
                                lg: 6,
                                label: "Taluka",
                                value:
                                    dataObj.talukaNames !== null ? dataObj.talukaNames : "",
                            },
                            {
                                xs: 12,
                                sm: 6,
                                md: 6,
                                lg: 6,
                                label: "Area",
                                value:
                                    dataObj.areaNames !== null ? dataObj.areaNames : "",
                            },
                            {
                                xs: 12,
                                sm: 6,
                                md: 6,
                                lg: 6,
                                label: "User Name",
                                value:
                                    dataObj.userName !== null
                                        ? dataObj.userName
                                        : "",
                            },
                            {
                                xs: 12,
                                sm: 6,
                                md: 6,
                                lg: 6,
                                label: "Name",
                                value:
                                    dataObj.name !== null
                                        ? dataObj.name
                                        : "",
                            },
                            {
                                xs: 12,
                                sm: 6,
                                md: 6,
                                lg: 6,
                                label: "Employee Code",
                                value: dataObj.employeeCode !== null ? dataObj.employeeCode : "-",
                            },
                            {
                                xs: 12,
                                sm: 6,
                                md: 6,
                                lg: 6,
                                label: "Contact No",
                                value:
                                    dataObj.contactNo !== null ? dataObj.contactNo : "",
                            },
                            {
                                xs: 12,
                                sm: 6,
                                md: 6,
                                lg: 6,
                                label: "WhatsApp No",
                                value:
                                    dataObj.whatsAppNo !== null ? dataObj.whatsAppNo : "",
                            },
                            {
                                xs: 12,
                                sm: 6,
                                md: 6,
                                lg: 6,
                                label: "Email Id",
                                value:
                                    dataObj.emailId !== null ? dataObj.emailId : "",
                            },
                        ];


                        this.setState({ DataToSet });
                    }
                });
            }
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }

    render() {
        const { dynamicMasterData, DataToSet } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        p: 1.5,
                        borderRadius: 0,
                    }}
                    elevation={0}
                >
                    <DynamicFormWithoutSave
                        showBackToList={true}
                        DataToSet={DataToSet}
                        dynamicMasterData={dynamicMasterData}
                        showSaveBtn={DriverJson.showSaveBtn}
                        showTitle={true}
                        screenTitle={"Driver View"}
                        showCancel={DriverJson.showCancel}
                        apiBaseURL={DriverJson.apiBaseURL}
                        showSaveNextBtn={false}
                        saveBtnText={"Search"}
                        showSaveBtnMain={false}
                        padding={true}
                        paddingTop={true}
                    />

                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    showNotification,
    showLoador,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(DriverView);
